import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueMarkdown from 'vue-markdown';
import LevelTable from '@/components/LevelTable.vue';
import ImageWithLoading from '@/components/ImageWithLoading.vue';
import BackButton from '@/components/BackButton.vue';
let ClassDetail = class ClassDetail extends Vue {
    get isDark() {
        return this.$vuetify.theme.dark;
    }
};
__decorate([
    Prop(Object)
], ClassDetail.prototype, "classData", void 0);
__decorate([
    Prop(Boolean)
], ClassDetail.prototype, "isHidingBack", void 0);
ClassDetail = __decorate([
    Component({
        components: {
            VueMarkdown,
            LevelTable,
            BackButton,
            ImageWithLoading
        }
    })
], ClassDetail);
export default ClassDetail;
